"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
/* eslint-disable global-require */
var _default = {
  framerate: 24,
  images: [require('./sideSprite.png')],
  frames: [[1155, 2, 572, 671, 0, -1082, -343], [1731, 2, 572, 671, 0, -1082, -343], [2307, 2, 572, 671, 0, -1082, -343], [2316, 1350, 573, 669, 0, -1081, -344], [1736, 1350, 576, 669, 0, -1078, -344], [1159, 1350, 573, 669, 0, -1081, -344], [582, 1350, 573, 669, 0, -1081, -344], [2, 1350, 576, 669, 0, -1078, -344], [3464, 677, 573, 669, 0, -1081, -344], [2888, 677, 572, 669, 0, -1082, -344], [579, 2, 572, 671, 0, -1082, -343], [2, 2, 573, 671, 0, -1081, -343], [1158, 677, 573, 669, 0, -1081, -344], [580, 677, 574, 669, 0, -1079, -344], [1735, 677, 573, 669, 0, -1081, -344], [2883, 2, 572, 671, 0, -1082, -343], [2, 677, 574, 669, 0, -1079, -344], [3459, 2, 573, 669, 0, -1081, -344], [2312, 677, 572, 669, 0, -1082, -344], [2893, 1350, 576, 669, 0, -1078, -344], [3473, 1350, 573, 669, 0, -1081, -344], [2, 2023, 573, 669, 0, -1081, -344]],
  animations: {
    'talk loop': {
      frames: [0, 0, 0, 3, 3, 4, 4, 4, 5, 5, 0, 0, 6, 6, 7, 7, 7, 8, 8, 9, 9, 10, 10, 11, 11, 11, 12, 12, 9, 9, 9, 8, 8, 7, 7, 7, 13, 13, 9, 9, 14, 14, 7, 7, 7, 5, 5, 15, 15, 12, 12, 4, 4, 4, 12, 12, 9, 9, 0, 0, 16, 16, 16, 17, 17, 18, 18, 18, 8, 8, 19, 19, 19, 3, 3, 4, 4, 4, 20, 20, 2, 2, 21, 21, 7, 7, 7, 8, 8],
      speed: 1
    },
    'stand idle': {
      frames: [0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 1, 1, 2, 2, 1, 1, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0],
      speed: 1
    }
  }
};
exports["default"] = _default;